import { CircularProgress } from '@epilot/concorde-elements'
import classNames from 'classnames'

import classes from './SpinnerPage.module.scss'

export const SpinnerPage = ({ isInShadowDOM }: { isInShadowDOM?: boolean }) => {
  return (
    <div
      className={classNames(
        classes.spinner,
        isInShadowDOM && classes['is-in-shadow-dom']
      )}
    >
      <CircularProgress color={isInShadowDOM ? '#005eb4' : undefined} />
    </div>
  )
}
